// extracted by mini-css-extract-plugin
export var boxItems = "_6l-1";
export var button = "_6l-5";
export var filterGroupBox = "_6l-0";
export var icon = "_6l-2";
export var iconSecondary = "_6l-4";
export var iconWrapper = "_6l-3";